import React from 'react';
import Iframe from 'react-iframe';
// import { Button } from 'react-bootstrap';

export default function YotiScreen({url, signOut}) {

    return (
      <div className="yoti-screen" style={{
        // width:"100%",
        // height:"100%",
      }}>
        {/* {signOut &&
          <Button
            block
            style={{width: "100%"}}
            onClick={signOut}
          >
              Sign Out
          </Button>
        } */}
        <Iframe
          url={url}
          width="100%"
          height="100%"
          allow="camera"
        />
      </div>
    );
}